export enum PrintProcessorType {
  Unknown,
  PlanetPress
}
